import { ITypedReduxAction } from '../../types/redux/actionType';
import { ERequestTrigger } from '../../types/requestTrigger';
import { TChatListSetSucceedPayload } from '../chatList';

export enum EStarredChatsListActionTypes {
  SetPending = 'chats/starredChatsList/setPending',
  SetSucceed = 'chats/starredChatsList/setSucceed',
  SetFailed = 'chats/starredChatsList/setFailed',
}

export interface IStarredChatsListRequest {
  // timestamp последнего чата, последней страницы
  timestampStarred?: number;
  /** Источник запроса, пишется в логи */
  trigger?: ERequestTrigger;
}

export type TStarredChatsListActions =
  | ITypedReduxAction<EStarredChatsListActionTypes.SetPending, IStarredChatsListRequest>
  | ITypedReduxAction<EStarredChatsListActionTypes.SetSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<EStarredChatsListActionTypes.SetFailed, void>;
